import MenuItem from '@mui/material/MenuItem';
import styled from 'styled-components';
import { DefaultModalComponents } from '../../ProjectModal/utils';
import AppCSS from '../../../utils/styled';
import { Form } from 'formik';
import { ReactComponent as ArrowDownIcon } from '../../../assets/icons/icon-arrow-down.svg';

export const Components = {
  ...DefaultModalComponents,
  FormButtonsContainer: styled.div`
    padding-top: 28px;
    width: 100%;
    grid-gap: 24px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  `,
  PrimaryButton: styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    max-height: 40px;
    min-width: max-content;
    padding: 10px 16px;
    ${AppCSS.fonts.h5};
    color: ${AppCSS.colors.white};
    background-color: ${AppCSS.colors.blues.dark};
    border: none;
    cursor: pointer;
  `,

  AddButton: styled(AppCSS.buttonStyles.SecondaryButtonStyle)`
    margin-top: 4px;
    min-width: 140px;
  `,

  TertiaryButton: styled(AppCSS.buttonStyles.TertiaryButtonStyle)``,

  Form: styled(Form)`
    width: 100%;
  `,

  FieldsWrapper: styled.div`
    width: 100%;
    display: grid;
    grid-template-columns: 3px calc(100% - 11px);
    grid-column-gap: 8px;
  `,
  FieldsContent: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 12px;
  `,
  FieldStartAdornment: styled.div<{ variant: 'minimal' | 'readyToPlay' | 'additional' }>`
    min-height: 24px;
    height: auto;
    width: 3px;
    ${AppCSS.radiuses.small};
    background-color: ${({ variant }) => {
      switch (variant) {
        case 'minimal':
          return AppCSS.colors.red;
        case 'readyToPlay':
          return AppCSS.colors.orange;
        case 'additional':
          return AppCSS.colors.greys.darker;
      }
    }};
  `,

  FieldWrapper: styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 12px;
  `,
  FieldLabel: styled.span`
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  BasicText: styled.span`
    ${AppCSS.fonts.paragraph12Regular};
    color: ${AppCSS.colors.blues.veryDark};
    white-space: pre-line;
  `,

  LengthInputsWrapper: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  `,

  MenuItem: styled(MenuItem)`
    padding: 8px;
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.black};
  `,

  UploadFileWrapper: styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  `,

  InputMenu: styled.input`
    visibility: visible;
    width: 0;
    margin-right: -8px;
  `,

  IconWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    cursor: pointer;
  `,

  UploadButton: styled.label`
    min-width: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${AppCSS.colors.white};
    padding: 12px 24px;
    ${AppCSS.radiuses.small};
    border: 1px solid ${AppCSS.colors.greys.medium};
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.black};
    cursor: pointer;
  `,

  ClearButton: styled.div`
    min-width: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${AppCSS.colors.white};
    padding: 12px 24px;
    ${AppCSS.radiuses.small};
    border: 1px solid ${AppCSS.colors.greys.medium};
    ${AppCSS.fonts.label12Bold};
    color: ${AppCSS.colors.red};
    cursor: pointer;
  `,

  Picker: styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 8px;
    cursor: pointer;
    ${AppCSS.radiuses.small};
    border: 1px solid ${AppCSS.colors.greys.medium};
    background-color: transparent;
    overflow: hidden;
    width: 100%;
    padding: 12px;
  `,
  PickerIconWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
  `,
  PickerLabel: styled.span`
    flex: 1;
    ${AppCSS.fonts.label12Medium};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  PickerIcon: styled(ArrowDownIcon)`
    height: 16px;
    width: 16px;
  `,
  NotSetLabel: styled.span`
    ${AppCSS.fonts.label12Medium};
    color: ${AppCSS.colors.black};
    flex: 1;
  `,
  TableWrapper: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    ${AppCSS.boxShadows.block};
  `,
  TagsContainer: styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 8px;
    border: 1px solid ${AppCSS.colors.greys.medium};
    border-radius: 4px;
    min-height: 40px;
  `,
  Tag: styled.div`
    display: flex;
    align-items: center;
    background-color: ${AppCSS.colors.blues.dark};
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 14px;
  `,
  RemoveTagButton: styled.button`
    background: none;
    border: none;
    color: white;
    margin-left: 4px;
    cursor: pointer;
    padding: 0 4px;
    font-size: 16px;
    line-height: 1;
    &:hover {
      opacity: 0.8;
    }
  `,
  TagInput: styled.input`
    border: none;
    outline: none;
    flex: 1;
    min-width: 120px;
    font-size: 14px;
    &::placeholder {
      color: ${AppCSS.colors.greys.medium};
    }
  `,
};
